module.exports = __webpack_public_path__ + "static/media/cancellationPolicy-blue.b4b9e73a.svg";